export const isMobile = (useMediaQuery) => {
  return useMediaQuery({ query: "(max-width: 840px)" });
};

export const isXSBreakpoint = (useMediaQuery) => {
  return useMediaQuery({ query: "(max-width: 480px)" });
};

export const xSmallBreakpoint = (useMediaQuery) => {
  return useMediaQuery({ query: "(max-width: 576px)" });
};

export const x800Breakpoint = (useMediaQuery) => {
  return useMediaQuery({ query: "(max-width: 800px)" });
};

export const isLaptop = (useMediaQuery) => {
  return useMediaQuery({ query: "(max-width: 1024px)" });
};

export const isLgBreakpoint = (useMediaQuery) => {
  return useMediaQuery({ query: "(max-width: 1280px)" });
};